import { OcrElement } from "../types"
import { getOcrFigureStyle, getOcrImageStyle } from "./ocrImageDimensions"
import { normalizeOcrLatexForTiptap } from "./normalizeOcrLatexForTiptap"

const formatTextContent = (content: string): string => {
  return normalizeOcrLatexForTiptap(content) || "<p></p>"
}

const sortElements = (elements: OcrElement[]): OcrElement[] => {
  return [...elements]
    .filter((el) => el.type !== "visualization" && el.bbox != null)
    .sort((a, b) => {
      const aPage = a.page_count || 1
      const bPage = b.page_count || 1
      if (aPage !== bPage) return aPage - bPage

      const aY = (a.fix_width_bbox || a.bbox)?.[1] || 0
      const bY = (b.fix_width_bbox || b.bbox)?.[1] || 0
      return aY - bY
    })
}

export const ocrElementsToFlowHtml = (elements: OcrElement[]): string => {
  const sorted = sortElements(elements)

  if (sorted.length === 0) {
    return "<p></p>"
  }

  return sorted
    .map((el) => {
      if (el.type === "text") {
        return formatTextContent(el.content)
      }

      if (el.type === "figure" || el.type === "graph") {
        const label = el.type === "figure" ? "Figure" : "Graph"
        const figureStyle = getOcrFigureStyle(el)
        const imageStyle = getOcrImageStyle(el)

        return `<figure data-ocr-type="${el.type}" style="${figureStyle}"><img src="${el.content}" alt="${label}" data-ocr-type="${el.type}" style="${imageStyle}" class="tiptap-editor__image" /></figure>`
      }

      return ""
    })
    .join("")
}
